import { useState } from "react";
import { Info } from "lucide-react";

export default function PerfilIngresoModal() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Botón */}
      <button
        onClick={() => setOpen(true)}
        className="inline-flex  mt-4 text-xs items-center gap-2 rounded-lg bg-amber-400 px-5 py-2.5 font-medium text-amber-900 shadow-sm transition-all hover:bg-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-300"
      >
        {" "}
        <Info className="h-5 w-5" /> Más información{" "}
      </button>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="relative w-full max-w-3xl rounded-xl bg-white shadow-xl">
            {/* Header */}
            <div className="flex items-center justify-between border-b px-6 py-4">
              <h2 className="text-xl font-semibold text-gray-800">
                Información para postulantes
              </h2>

              <button
                onClick={() => setOpen(false)}
                className="text-2xl text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            </div>

            {/* Contenido */}
            <div className="max-h-[70vh] overflow-y-auto px-6 py-5 space-y-4 text-gray-700 leading-7">
              <p>
                Los postulantes deberán evidenciar disposición y habilidades
                académicas iniciales acordes al nivel de posgrado, que les
                permitan sostener el proceso formativo, tales como comprensión
                lectora, razonamiento básico, aprendizaje autónomo y manejo de
                herramientas digitales.
              </p>

              <p>
                Se espera que los postulantes demuestren motivación y coherencia
                entre sus objetivos personales y profesionales y el enfoque del
                programa, capacidad de organización del tiempo y autorregulación
                académica, y habilidades iniciales de pensamiento crítico para
                enfrentar y reflexionar sobre retos académicos y profesionales.
              </p>

              <p>
                De igual manera, los postulantes declararán su trayectoria
                académica y/o profesional, así como la formación continua y
                otros méritos relevantes, en función de la naturaleza del
                programa.
              </p>
            </div>

            {/* Footer */}
            <div className="flex justify-end border-t px-6 py-4">
              <button
                onClick={() => setOpen(false)}
                className="rounded-lg bg-gray-200 px-4 py-2 text-gray-700 hover:bg-gray-300 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
